import Image from 'next/image'
import Link from 'next/link'

import iconWhatsAppSocial from '@assets/Icon-Whatsapp-footer.webp'
import iconYouTubeSocial from '@assets/Icon-Youtube-footer.webp'
import iconFacebookSocial from '@assets/Icon-Facebook-footer.webp'
import iconInstagramSocial from '@assets/Icon-Instagram-footer.webp'
import iconLinkedInSocial from '@assets/Icon-Linkedin-footer.webp'

interface SocialsProps {
  className?: string
}

export function Socials({ className }: SocialsProps) {
  return (
    <div className={className}>
      <p className="text-xs leading-5 font-bold text-v3-gray-400 mb-4 md:text-base md:leading-[1.375rem] md:mb-0">
        Redes Sociais
      </p>

      <div className="w-full flex items-center justify-between md:ml-[-14px]">
        <Link
          href="https://api.WhatsApp.com/send?phone=11972132657"
          target="_blank"
          aria-label="WhatsApp do Portal Solar"
          rel="noreferrer"
        >
          <span className="sr-only">Acesse nosso WhatsApp</span>
          <Image
            src={iconWhatsAppSocial}
            className="w-8 h-8 md:w-16 md:h-16"
            alt="Ícone do WhatsApp"
          />
        </Link>

        <Link
          href="https://www.youtube.com/channel/UCJ9aMiOTnwhRn2QV-DE_xiQ"
          target="_blank"
          aria-label="Canal do YouTube Portal Solar"
          rel="noreferrer"
        >
          <span className="sr-only">Acesse nosso canal no YouTube</span>
          <Image
            src={iconYouTubeSocial}
            className="w-8 h-8 md:w-16 md:h-16"
            alt="Ícone do YouTube"
          />
        </Link>

        <Link
          href="https://pt-br.facebook.com/PortalSolarBrasil/"
          target="_blank"
          aria-label="Página do Facebook Portal Solar"
          rel="noreferrer"
        >
          <span className="sr-only">Acesse nossa página no Facebook</span>
          <Image
            src={iconFacebookSocial}
            className="w-8 h-8 md:w-16 md:h-16"
            alt="Ícone do Facebook"
          />
        </Link>

        <Link
          href="https://www.instagram.com/portal_solar/?hl=pt-br"
          target="_blank"
          aria-label="Perfil do Instagram Portal Solar"
          rel="noreferrer"
        >
          <span className="sr-only">Acesse nosso perfil no Instagram</span>
          <Image
            src={iconInstagramSocial}
            className="w-8 h-8 md:w-16 md:h-16"
            alt="Ícone do Instagram"
          />
        </Link>

        <Link
          href="https://www.linkedin.com/company/portal-solar/"
          target="_blank"
          aria-label="Página do LinkedIn Portal Solar"
          rel="noreferrer"
        >
          <span className="sr-only">Acesse nossa página no LinkedIn</span>
          <Image
            src={iconLinkedInSocial}
            className="w-8 h-8 md:w-16 md:h-16"
            alt="Ícone do LinkedIn"
          />
        </Link>
      </div>
    </div>
  )
}
